import { render, staticRenderFns } from "./ForRentDetails.vue?vue&type=template&id=87b914a6&"
import script from "./ForRentDetails.vue?vue&type=script&lang=js&"
export * from "./ForRentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports